import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { ValidateData } from "../../utils/validate-data";

export class ValidatorsCustom {
  public static validDateMin(minDate: Date): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = new Date(control.value);
      return value.getTime() < minDate.getTime()
        ? { minDate: { min: minDate.getTime(), actual: value.getTime() } }
        : null;
    };
  }

  public static validSevenCero(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (value == "0000000") {
        return { isSevenCero: true };
      }
      return null;
    };
  }

  public static validDateMax(maxDate: Date): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = new Date(control.value);
      return maxDate.getTime() < value.getTime()
        ? { maxDate: { max: maxDate.getTime(), actual: value.getTime() } }
        : null;
    };
  }

    public static validarFechaMinimoYMaximo(
      minDate: Date = new Date(),
      maxDate: Date = new Date()
    ): ValidatorFn {
      if (!minDate && !maxDate) {
        return null;
      }

      // Normalizar fechas para evitar diferencias en horas
      minDate.setHours(0, 0, 0, 0);
      maxDate.setHours(23, 59, 59, 999); // Permitir cualquier hora dentro del día actual

      return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null; // No validar si el campo está vacío

        let value: Date;
        if (typeof control.value === 'string') {
          // Extraer año, mes y día para evitar problemas de zona horaria
          const [year, month, day] = control.value.split('-').map(Number);
          value = new Date(year, month - 1, day); // Mes empieza en 0
        } else {
          value = new Date(control.value);
        }

        value.setHours(0, 0, 0, 0); // Normalizar la fecha seleccionada

        return value.getTime() < minDate.getTime() || value.getTime() > maxDate.getTime()
          ? {
              minDate: { min: minDate.toISOString(), actual: value.toISOString() },
              maxDate: { max: maxDate.toISOString(), actual: value.toISOString() },
            }
          : null;
      };
    }

  public static validarRangoSalarioConyuge(
    minimo: number,
    maximo: number
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (minimo && maximo) {
        return value < minimo || value > maximo
          ? {
              salarioMinimoConyuge: { min: minimo, actual: value },
              salarioMaximoConyuge: { max: maximo, actual: value },
            }
          : null;
      }

      return value < minimo
        ? {
            salarioMinimoConyuge: { min: minimo, actual: value },
          }
        : null;
    };
  }

  public static messageError(message: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return !ValidateData.emptyString2(message)
        ? { messageError: message }
        : null;
    };
  }

  public static patternCustom(pattern: RegExp, message: string) {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const reg = new RegExp(pattern);
      return !ValidateData.emptyString(pattern + "") && !reg.test(value)
        ? { messageError: message }
        : null;
    };
  }

  public static documentoDiferenteTelefono(getTelefono: () => string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const documento = control.value;
      const telefono = getTelefono();

      if (documento && telefono && documento === telefono) {
        return { documentoIgualTelefono: true };
      }

      return null;
    };
  }

  public static telefonoDiferenteDocumento(getDocumento: () => string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const telefono = control.value;
      const documento = getDocumento();

      if (telefono && documento && telefono === documento) {
        return { telefonoIgualDocumento: true };
      }

      return null;
    };
  }

  public static documentoDiferenteEmpresa(getDocNumberCompany: () => string | undefined,getcheckDigit: () => string | undefined): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const documento = control.value;
      const docNumberCompany = getDocNumberCompany();
      const docNumberCompanyCheck = getDocNumberCompany()+""+getcheckDigit();

      if ((documento === docNumberCompany)||(documento ===docNumberCompanyCheck )) {
        return { documentoIgualEmpresa: true };
      }

      return null;
    };
  }

  public static documentoDiferenteTrabajador(getTrabajadorDoc: () => string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const docConyuge = control.value;
      const docTrabajador = getTrabajadorDoc();

      if (docConyuge && docTrabajador && docConyuge === docTrabajador) {
        return { documentoIgualTrabajador: true };
      }

      return null;
    };
  }
  public static documentoDiferenteConyuge(getConyugeDoc: () => string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const docBeneficiario = control.value;
      const docConyuge = getConyugeDoc();

      if (docBeneficiario && docConyuge && docBeneficiario === docConyuge) {
        return { documentoIgualConyuge: true };
      }

      return null;
    };
  }

  public static documentoDiferenteBeneficiarios(getBeneficiariosDocs: () => string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const docBeneficiario = control.value;
      const docsExistentes = getBeneficiariosDocs();

      if (docBeneficiario && docsExistentes && docsExistentes.includes(docBeneficiario)) {
        return { documentoIgualBeneficiario: true };
      }

      return null;
    };
  }

  public static validadorDocumentoDiferenteTrabajador(getTrabajadorDoc: () => string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const docform = control.value;
      const docTrabajador = getTrabajadorDoc();

      if (docform && docTrabajador && docform === docTrabajador) {
        return { documentoIgualTrabajador: true };
      }

      return null;
    };
  }
  
}


